@if (markers()?.length) {
  <app-map
    [id]="mapId"
    class="on-call-map"
    [markers]="markers()"
    [invalidateSize$]="splitterEvents.resizeEnd$"
    [toggleMarkerClustering$]="toggleMarkerClustering$"
    [customTemplate]="{
      template: menuPanelTemplate,
      isFullScreenTemplate: false,
    }"
    [useMarkerClustering]="true"
    [autoZoomFit$]="autoZoomFit$"></app-map>
}

<ng-template #menuPanelTemplate>
  <app-timed-marker-map-menu-panel
    [mapSetting]="mapSetting"
    [showAddressSearch]="true"
    [showSettings]="true"
    [customForm]="customMapSettingsForm"
    [customFormElements]="customMapSettingsElements"
    [markerGroupEnabled]="false"
    [showLocationsLegend]="true"
    [showCarIcons]="true"
    [slideToggleLabel]="'OnCallMap.ShowOnlyStandby' | translate"
    (autoRefreshClicked)="onAutoRefreshClicked($event)"
    (searchAddressChanged)="onSearchAddressChanged($event)"
    (slideToggleClicked)="onShowOnlyStandbyClick($event)"
    (autoZoomFitClicked)="onAutoZoomFitClicked($event)"
    (groupMarkersClicked)="onGroupMarkersClicked($event)"
    (customFormChanged)="
      onCustomSettingsChanged($event)
    "></app-timed-marker-map-menu-panel>
  @if (searchResult$ | async; as addresses) {
    <app-address-search-result-box
      [addresses]="addresses"
      (addressSelected)="
        onAddressSelected($event)
      "></app-address-search-result-box>
  }
</ng-template>
